<template>
  <div>
    <TopNav :t='timer' :m='minute' :s='second' />
    <div class="main-content">
      <!-- HEADER -->
      <div class="header">
        <div class="container">
          <div class="header-body">
            <div class="row align-items-end">
              <Head v-bind:route="'SmallQuiz'" />
            </div>
          </div>
          <div class="container pt-5">
            <div class="row">
              <div class="col-12" v-if="message">
                <div class="alert" :class='alert_class'>{{ message }}</div>
              </div>
              <div class="col-12" v-else-if="status && start_button_name != ''">
                <a @click="startQuiz()" href="javascript:;" class="btn btn-primary btn-lg mb-4 float-right lift">{{ start_button_name }}</a>
              </div>
              <div class="col-12 text-right" v-if="quiz_after">
                <a href="javascript:;" @click="back()" class="btn btn-primary btn-lg mb-4 mr-3 lift">
                  <i class="fe fe-arrow-left"></i> Önceki Ekrana Dön
                </a>
                <a @click="tryAgain()" v-if="quiz_result.score < 100" href="javascript:;" class="btn btn-primary btn-lg mb-4 lift">Sınavı Tekrarla</a>
              </div>
              <div class="col-12" v-if="subject.ders_adi && subject.konu_adi && subject.unite_adi && access">
                <h1>{{ subject.ders_adi }}</h1>
                <p class="lead text-muted">{{ subject.unite_adi }} / {{ subject.konu_adi }}</p>
              </div>
              <div v-if="completed" class="col-12">
                <div class="jumbotron jumbotron-fluid">
                  <div class="container">
                    <h1 class="display-4">Kısa Sınav Sonuçları</h1>
                    <h3>Bu sınavı <span class="badge badge-primary">{{ try_count }}</span> defa denedin.</h3>
                    <div class="card">
                      <div class="card-body">
                        <div class="list-group list-group-flush my-n3">
                         
                          <div class="list-group-item">
                            <div class="row align-items-center">
                              <div class="col">
                                <h5 class="mb-0">
                                  <span class="text-success">●</span> DOĞRU CEVAP
                                </h5>
                              </div>
                              <div class="col-auto">
                                <p class="text-success small">{{ quiz_result.true }}</p>
                              </div>
                            </div>
                          </div>

                           <div class="list-group-item">
                            <div class="row align-items-center">
                              <div class="col">
                                <h5 class="mb-0">
                                  <span class="text-danger">●</span> YANLIŞ CEVAP
                                </h5>
                              </div>
                              <div class="col-auto">
                                <p class="text-danger small">{{ quiz_result.false }}</p>
                              </div>
                            </div>
                          </div>

                           <div class="list-group-item">
                            <div class="row align-items-center">
                              <div class="col">
                                <h5 class="mb-0">
                                  <span class="text-warning">●</span> BOŞ CEVAP
                                </h5>
                              </div>
                              <div class="col-auto">
                                <p class="text-warning small">{{ quiz_result.empty }}</p>
                              </div>
                            </div>
                          </div>

                          <div class="list-group-item">
                            <div class="row align-items-center">
                              <div class="col">
                                <h5 class="mb-0">
                                  <span class="text-muted">●</span> PUAN
                                </h5>
                              </div>
                              <div class="col-auto">
                                <p class="text-dark small">100/{{ quiz_result.score }}</p>
                              </div>
                            </div>
                          </div>

                        </div>

                        <div class="row align-items-center">
                          <div class="col">
                            <div class="row align-items-center no-gutters">
                              <div class="col-auto">
                                <div class="small mr-2">BAŞARI ORANI: {{ quiz_result.score }}%</div>
                              </div>
                              <div class="col">
                                <div class="progress progress-sm">
                                  <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" :style="'width: ' + quiz_result.score + '%'" :aria-valuenow="quiz_result.score" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="!completed || quiz_after" :class="!timer && !quiz_after ? 'blurred' : ''" class="col-12">
                <Quiz :end="quiz_after" :qkey="getQuizKey" :question="q" :key="index" :index="index" v-for="(q, index) in questions" />
              </div>
              <div class="col-12 mt-4 mb-2 text-right" v-if="timer && ! quiz_after">
                <a @click="saveQuiz()" href="javascript:;" class="btn btn-primary btn-lg lift"><i class="fe fe-send"></i> {{ complete_button_name }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopNav from '@/components/TopNav';
import Head from '@/components/Head';
import Quiz from '@/components/Quiz';
import base from '@/mixins/base'
import http from '@/helpers/http';
import { Base64 } from 'js-base64'; // eslint-disable-line

export default {
  name: 'IncompleteCompletionQuiz',
  components: { TopNav, Head, Quiz },
  mixins: [ base ],
  data () {
    return {
      message: 'Sorular yükleniyor...',
      questions: {},
      subject: {},
      alert_class: 'alert-danger',
      status: null,
      start_button_name: '',
      quiz_after: false,
      timer: false,
      minute: '00', // Remaining Minutes
      second: '00', // Remaining Seconds
      completed: false,
      complete_button_name: 'Sınavı Bitir',
      finish_date: 0,
      timeCalculator: null,
      access: true,
      try_count: 0,
      quiz_result: {
        true: 0,
        false: 0,
        empty: 0,
        percentage: 0,
        score: 0,
      }
    }
  },
  computed: {
    getQuizKey: function () {
      return this.$route.params.exam_id+'-'+this.$route.params.lesson_id+'-'+this.$route.params.sub_id+'-'+this.$route.params.question_id
    }
  },
  methods: {
    saveQuiz () {
      if (this.timer) {
        this.quiz_after = true
        this.complete_button_name = ''
        this.completed = true
        this.timer = false
        this.status = false
        this.computeResult()
        clearInterval(this.timeCalculator)
        window.scrollTo(0,0);
      }
    },
    back () {
      base.methods.incompleteCompletionData(this.$store.state.auth.student_id)
      this.$router.push({name: 'IncompleteCompletionDetail', params: { id: this.$route.params.exam_id, sub_id: this.$route.params.lesson_id }});
    },
    tryAgain() {
      
      this.questions = {}
      localStorage.removeItem(this.getQuizKey + '_finish_date')
      // localStorage.removeItem(this.getQuizKey + '_answers')

      http.post('quiz', {
        ogrenciID: this.$store.state.auth.student_id,
        sinif: this.$store.state.auth.student.SINIF,
        altkonuID: this.$route.params.sub_id,
        sinavID: this.$route.params.exam_id,
        dersID: this.$route.params.lesson_id,
        soruID: this.$route.params.question_id
      }).then(response => {
        this.$nprogress.done()
        if (typeof response.data == 'object' && response.data[0] != undefined) {

          this.quiz_after = false
          this.message = ''
          this.completed = false
          this.questions = response.data
          this.status = true
          this.complete_button_name = 'Sınavı Bitir'
          this.start_button_name = 'Sınavı Başlat'
        }
      }).catch(error => {
        this.$nprogress.done()
        throw error;
      });

    },
    startQuiz (f_date = null) {
      let preCount = 3;
      this.timeCalculator = setInterval(() => {

        if (! this.quiz_after) {
          if (! this.timer) {

            if (preCount < 1) {

              this.start_button_name = '';
              
              this.timer = true
              if (f_date !== null) {

                this.finish_date = parseInt(f_date);

              } else {

                let t = new Date()
                t.setSeconds(t.getSeconds() + this.questions['toplam_sure']);
                this.finish_date = this.time(t)
                localStorage.setItem(this.getQuizKey + '_finish_date', this.finish_date)
              }
              let calc = this.secondToTime(this.finish_date - this.time())
            
              this.minute = calc.m.toString().padStart(2, '0')
              this.second = calc.s.toString().padStart(2, '0')

            } else {
              this.start_button_name = '...'+preCount+'...'
              preCount--
            }

          } else {
            
            if (this.finish_date == 0) {
              this.finish_date = localStorage.getItem(this.getQuizKey + '_finish_date')
            }
            let calc = this.secondToTime(this.finish_date - this.time())
            
            this.minute = calc.m.toString().padStart(2, '0')
            this.second = calc.s.toString().padStart(2, '0')

            if (parseInt(this.minute) <= 0 && parseInt(this.second) <= 0) {
              this.saveQuiz()
              clearInterval(this.timeCalculator)
            }
          }
        }
      }, 1000);
    },
    computeResult () {
      
      this.$nprogress.start()

      http.post('quiz-sonuclar', {
        ogrenciID: this.$store.state.auth.student_id,
        altkonuID: this.$route.params.sub_id,
        sinavID: this.$route.params.exam_id,
        dersID: this.$route.params.lesson_id,
        quizNo: this.questions[0].quiz_no,
        soruID: this.$route.params.question_id
      }).then(response => {
        this.$nprogress.done()

        let true_answer = 0;
        let false_answer = 0;
        let empty_answer = 0;

        Object.entries(response.data).forEach(([key, q]) => { // eslint-disable-line
          let student_answer = q.ogrenci_cevap;

          if (student_answer == '' || student_answer == null) {
            empty_answer++
          } else if (student_answer == q.soru_cevap) {
            true_answer++
          } else {
            false_answer++
          }
        })

        this.quiz_result.true = true_answer
        this.quiz_result.false = false_answer
        this.quiz_result.empty = empty_answer

        let balance = 100 / (parseInt(true_answer) + parseInt(false_answer) + parseInt(empty_answer));

        if (true_answer) {
          this.quiz_result.score = Math.round(this.quiz_result.true * balance);
        }

      }).catch(error => {
        this.$nprogress.done()
        throw error;
      });

      /*

      let storage = localStorage.getItem(this.getQuizKey + '_answers')
      if (localStorage.getItem(this.getQuizKey + '_answers')) {
        storage = JSON.parse(localStorage.getItem(this.getQuizKey + '_answers'))
      }

      Object.entries(this.questions).forEach(([key, answer]) => {

        if (key !== 'toplam_sure') {
          let student_answer = answer.ogrenci_cevap;
          
          if (storage[key] !== null && storage[key] !== undefined) {
            student_answer = storage[key]
          }

          if (student_answer == '' || student_answer == null) {
            empty_answer++
          } else if (student_answer == Base64.decode(answer.soru_cevap)) {
            true_answer++
          } else {
            false_answer++
          }
        }
      })
      */
      
      this.try_count++

    }
  },
  created() {
    this.deviceTimeNConnectionCheck();

    for (let s in this.$store.state.exam.incomplete_completion) {
      if (this.$store.state.exam.incomplete_completion[s].id == this.$route.params.exam_id) { // Exam

        let exams = this.$store.state.exam.incomplete_completion[s].json
        for (let exam of Object.entries(exams)) {
          exam = exam[1][0]
          if (exam.ders_id == this.$route.params.lesson_id) { // Lesson
            for (let l in exam.soru_bilgileri) {
              if (exam.soru_bilgileri[l].soru_id == this.$route.params.question_id) { // Subject

                this.subject.ders_adi = exam.ders_isim
                this.subject.unite_adi = exam.soru_bilgileri[l].unite_adi
                this.subject.konu_adi = exam.soru_bilgileri[l].konu_adi
                
                if (exam.soru_bilgileri[l].quiz === 'success') {
                  this.access = false
                  this.alert_class = 'alert-success'
                  this.quiz_after = true
                  this.quiz_result.score = 100,
                  this.message = 'Bu sınavı 100% başarı ile tamamladın. Bu yüzden tekrar girmene gerek yok.'
                }

                this.try_count = exam.soru_bilgileri[l].quiz_count

                if (this.access) {
                  http.post('quiz', {
                    ogrenciID: this.$store.state.auth.student_id,
                    sinif: this.$store.state.auth.student.SINIF,
                    altkonuID: this.$route.params.sub_id,
                    sinavID: this.$route.params.exam_id,
                    dersID: this.$route.params.lesson_id,
                    soruID: this.$route.params.question_id
                  }).then(response => {
                    this.$nprogress.done()
                    if (typeof response.data == 'object' && response.data[0] != undefined) {
                      
                      this.message = ''
                      this.questions = response.data
                      this.status = true
                      this.start_button_name = 'Sınavı Başlat'

                      if (localStorage.getItem(this.getQuizKey + '_finish_date') !== null) {

                        this.startQuiz(localStorage.getItem(this.getQuizKey + '_finish_date'))
                      }

                      let answers = []
                      Object.entries(this.questions).forEach(([i, q]) => {
                        if (i !== 'toplam_sure') answers[i] = q.ogrenci_cevap
                      })
                      localStorage.setItem(this.getQuizKey + '_answers', JSON.stringify(answers))
                    } else {
                      this.message = 'Bu konu ile ilgili soru bulunamadı!'
                    }
                  }).catch(error => {
                    this.alert_class = 'alert-danger'
                    this.message = 'Bir sorun oluştu',
                    this.$nprogress.done()
                    throw error;
                  });
                }
                break;
              }
            }
          }
        }
        break;
      }
    }
  }
}
</script>
<style>
.b {
  -webkit-transition: 0.2s ease-out;
  -o-transition: 0.2s ease-out;
  transition: 0.2s ease-out
}

.blurred {
  -webkit-filter: blur(5px);
  filter: blur(5px);
  pointer-events: none;
}
</style>
